import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectIsPlaying,
} from "../redux/selectors/playerSelector";
import { useCallback } from "react";
import {
  playMedia,
  setCurrentContent,
  setCurrentMediaLink,
} from "../redux/Slice/playerSlice";

export const useTrackNavigation = () => {
  const dispatch = useDispatch();

  const isPlaying = useSelector(selectIsPlaying);
  const currentContent = useSelector(selectCurrentContent);

  const playlistReleases = useSelector(
    (state) => state.playlistReleases.playlistReleases,
  );

  const currentReleaseIndex = playlistReleases.findIndex(
    (release) => release.id === currentContent?.id,
  );

  const handleSkip = useCallback(
    (direction) => {
      const newIndex = currentReleaseIndex + direction;

      // Проверка границ плейлиста
      if (newIndex < 0 || newIndex >= playlistReleases.length) {
        return;
      }

      const newRelease = playlistReleases[newIndex];

      const action = isPlaying
        ? playMedia(newRelease.audioFileLink)
        : setCurrentMediaLink(newRelease.audioFileLink);

      dispatch(action);
      dispatch(setCurrentContent(newRelease));
    },
    [currentReleaseIndex, dispatch, isPlaying, playlistReleases],
  );

  return {
    handleSkip,
    hasPrevious: currentReleaseIndex > 0,
    hasNext: currentReleaseIndex < playlistReleases.length - 1,
  };
};
